// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__-oYAd","partner-title":"Partner_partner-title__zPZoN","partner-nav":"Partner_partner-nav__HvRQC","partner-item":"Partner_partner-item__+7oK3"};